import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from "../Images/logo black.png"
import "../Sass/Home.scss"

const Footer = () => {
    // useEffect(() => {
    //     const scriptId = 'google-translate-script'; // Unique ID for the script
    
    //     if (!document.getElementById(scriptId)) {
    //         const addScript = document.createElement('script');
    //         addScript.setAttribute(
    //             'src',
    //             '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    //         );
    //         addScript.id = scriptId; // Assign the unique ID
    //         document.body.appendChild(addScript);
    
    //         // Define the callback function
    //         window.googleTranslateElementInit = () => {
    //             new window.google.translate.TranslateElement(
    //                 {
    //                     pageLanguage: 'en',
    //                     autoDisplay: true,
    //                 },
    //                 'google_translate_element'
    //             );
    //         };
    //     }
    // }, []);
    
    return (
        <>
            <div id="footer">

                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <footer>
                    <div className="footer-content left">
                        <img src={logo} alt="logo" />
                        <p>TerraMinds Research is a premier market research firm specializing in online sample data collection and actionable insights. </p>
                    </div>
                    <div className="footer-content middle">
                        <h3>Address</h3>
                        <p><b>Headquarters :</b></p>
                        <p>5850 San Felipe St #500
                        Houston, TX 77057</p>

                        <p><b>India Operations Office :                        </b></p>
                        <p>1st Floor, 10 Poorvi Marg, City Court,
                            DLF City Phase 2 Gurugram, HR-122008, India</p>

                        <h3>Call Us</h3>
                        <a href="tel:+14093776998">+1 409 377 6998 </a>
                    </div>
                    <div className="footer-content right">
                        <h3>Email</h3>
                        <a href="mailto:Contact@terramindresearch.com">Contact@terramindresearch.com</a>
                        <a href="mailto:Sales@terramindresearch.com">Sales@terramindresearch.com</a>
                        <h3>Follow Us</h3>
                        <div className="footer-follow">

                            <a href="https://www.linkedin.com/company/terraminds-inc/posts/?feedView=all" target="_blank">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z"></path>
                                </svg>
                            </a>

                            <a href="#" target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" /></svg>                            </a>
                        </div>

                        <div className="footer-cert">
                            <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1695734799/Think_Tank/Footer/1_erkkta.png" alt="ISO 9001:2015" title='ISO 9001:2015' />
                            <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1695734799/Think_Tank/Footer/2_wdoxxx.png" alt="ISO 27001:2013" title='ISO 27001:2013' />
                            <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1695734800/Think_Tank/Footer/3_ogwfba.png" alt="ISO 20252:2012" title='ISO 20252:2012' />
                            <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1695706241/Think_Tank/Footer/SSL_m4wine.png" alt="SSL Secure" title='SSL Secure' />
                        </div>
                    </div>
                </footer>
                <div className="copyright">
                    <p><div>Copyright © {new Date().getFullYear()}. All Rights Reserved By <span>&nbsp; <a target='_blank' href="#">TerraMinds Inc.</a></span></div>
                        {/* <div id="google_translate_element"></div> */}
                        <Link to={'/privacy-policy'} className='pri'>Privacy Policy</Link>
                    </p>
                </div>

            </div>

        </>
    )
}

export default Footer
